import React from 'react';
import PropTypes from 'prop-types';

import {getVFSImageUrl} from '../../../listing-helper';
import ContinueButton from '../../mapbox-continue-button/index';
import GeneralInfo from '../mapbox-popup-general-info/index';
import CloseButton from '../react-closeButton/index';

import '../../../../styles/mobile-click-tooltip.scss';

class MobileClickTooltip extends React.Component {
  state = {
    VFSLoading: true,
    VFSLoadedSuc: false,
  };

  getVFSPath = () => {
    const {venueId, venueConfigId, sectionId, screenSize = 'small'} = this.props;

    return getVFSImageUrl({venueId, venueConfigId, sectionId, screenSize});
  };

  VFSLoadSuccessful = () => {
    this.setState({
      VFSLoading: false,
      VFSLoadedSuc: true,
    });
  };

  VFSLoadFailed = () => {
    this.setState({
      VFSLoading: false,
      VFSLoadedSuc: false,
    });
  };

  render() {
    const {onClose, section, row, seat, price, type, onContinue} = this.props;
    const {VFSLoadedSuc, VFSLoading} = this.state;
    const VFSPath = this.getVFSPath();

    return (
      <>
        {VFSLoadedSuc && !VFSLoading && (
          <CloseButton
            onClose={onClose}
            className="MapboxClickTooltipMobile_closeButtonWithVFS"
            color="#ffffff"
            width="12px"
            height="12px"
          />
        )}
        {VFSPath && (
          <img
            className={VFSLoadedSuc ? 'MapboxClickTooltipMobile_VFSSucStyle' : 'MapboxClickTooltipMobile_VFSUnsucStyle'}
            src={VFSPath}
            onLoad={() => {
              this.VFSLoadSuccessful();
            }}
            onError={() => {
              this.VFSLoadFailed();
            }}
          />
        )}

        <GeneralInfo
          section={section}
          row={row}
          seat={seat}
          price={price}
          type={type}
          onClose={((!VFSLoadedSuc && !VFSLoading) || !VFSPath) && onClose}
          className="MapboxClickTooltipMobile__Info"
        />

        <ContinueButton className="MapboxClickTooltipMobile__continueButton" onContinue={onContinue} />
      </>
    );
  }
}

MobileClickTooltip.propTypes = {
  /** The venue ID. */
  venueId: PropTypes.number.isRequired,

  /** The venue config ID. */
  venueConfigId: PropTypes.number.isRequired,

  /** The section ID. */
  sectionId: PropTypes.number.isRequired,

  /** The section name. */
  section: PropTypes.string.isRequired,

  /** The row id. */
  row: PropTypes.string.isRequired,

  /** The price with currency. */
  price: PropTypes.object.isRequired,

  /** The function to close the tooltip. */
  onClose: PropTypes.func.isRequired,

  /** The function to continue to the next step. */
  onContinue: PropTypes.func.isRequired,

  /** The seat. */
  seat: PropTypes.string,

  /** The screen size. */
  screenSize: PropTypes.string,

  /** The type of tooltip. */
  type: PropTypes.string,
};

MobileClickTooltip.defaultProps = {
  seat: '',
  screenSize: 'small',
};

export default MobileClickTooltip;
